(ns minorodata.dependency-graph.timeline.api
  "Fetches execution history / logs for a transform's execution timeline.
  Results are written into `[:dependency-graph-timeline <master-id>]` via the timeline events."
  (:require
   ["date-fns-tz" :refer [formatInTimeZone fromZonedTime]]
   [clojure.string :as str]
   [minorodata.app.utils :refer [assoc-some get-browser-tz]]
   [mold-http.core :refer [reg-event-http]]))


(defn- api-url [s & [m]]
  (reduce (fn [s [k v]] (str/replace s (str "{" (name k) "}") (js/encodeURIComponent (str v))))
          s m))


(defn error-message
  "What the pane should tell the reader. kioku answers a bad window with
   `{:error \"Range too large: at most 366 days\"}` and similar — messages that
   say what to do next, so they are worth more than a generic failure line."
  [error fallback]
  (or (get-in error [:response :error])
      (get-in error [:response :message])
      fallback))


(defn fetch-executions-request [{:keys [db]} [{:keys [master-id started-at ended-at] :as params}]]
  ;; `fromZonedTime` with no zone yields an Invalid Date, and `.toISOString` on
  ;; one throws inside the request builder.
  (let [timezone (or (get-in db [:app :client-timezone]) (get-browser-tz))]
    {:http-xhrio
     {:url    (api-url "/api/execution-timeline/{master_id}"
                       {:master_id master-id})
      :method :GET
      ;; kioku expands these to whole *UTC* days, but the window is anchored to
      ;; the client timezone — sending its calendar date left up to a tz offset
      ;; of the visible window unfetched. The UTC date of each bound covers it.
      :params (assoc-some {}
                          :start-date (some-> started-at (fromZonedTime timezone) (formatInTimeZone "UTC" "yyyy-MM-dd"))
                          :end-date   (some-> ended-at (fromZonedTime timezone) (formatInTimeZone "UTC" "yyyy-MM-dd")))
      :cb-params params}}))

(defn fetch-executions-callback [_ [error resp {:keys [master-id]}]]
  (if (some? error)
    (let [message (error-message error "Could not load runs for this window.")]
      {:dispatch-n [[:dependency-graph.timeline.events/set-error {:master-id master-id
                                                    :request   :history
                                                    :error     message}]
                    [:app.api/log :error "Failed to fetch executions" error]]})
    {:dispatch [:dependency-graph.timeline.events/set-executions {:master-id master-id :executions resp}]}))

(reg-event-http
 :dependency-graph.timeline.api/fetch-executions
 fetch-executions-request
 fetch-executions-callback)


(defn fetch-executions-log-request [{:keys [db]} [{:keys [master-id started-at ended-at] :as params}]]
  (let [timezone (or (get-in db [:app :client-timezone]) (get-browser-tz))]
    {:http-xhrio
     {:url    (api-url "/api/execution-timeline/{master_id}/log"
                       {:master_id master-id})
      :method :GET
      :params (assoc-some {}
                          :start-time (some-> started-at (fromZonedTime timezone) .toISOString)
                          :end-time   (some-> ended-at  (fromZonedTime timezone) .toISOString))
      :cb-params params}}))

(defn fetch-executions-log-callback [_ [error resp {:keys [master-id]}]]
  (if (some? error)
    (let [message (error-message error "Could not load the execution log for this window.")]
      {:dispatch-n [[:dependency-graph.timeline.events/set-error {:master-id master-id
                                                    :request   :log
                                                    :error     message}]
                    [:app.api/log :error "Failed to fetch executions log" error]]})
    {:dispatch [:dependency-graph.timeline.events/set-logs {:master-id master-id :logs resp}]}))

(reg-event-http
 :dependency-graph.timeline.api/fetch-executions-log
 fetch-executions-log-request
 fetch-executions-log-callback)
